import { render, staticRenderFns } from "./MessengerSendMessage.vue?vue&type=template&id=5faa6572"
import script from "./MessengerSendMessage.vue?vue&type=script&lang=js"
export * from "./MessengerSendMessage.vue?vue&type=script&lang=js"
import style0 from "./MessengerSendMessage.vue?vue&type=style&index=0&id=5faa6572&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports